import React from 'react';
import { Grid, ISelectOption, SmallBodyText, Tooltip } from '../../../ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { Show } from '../../shared/Show';

export interface ISigningAppointmentDescriptionTooltipProps {
  type: string;
  option: ISelectOption;
  optionDescriptions: Record<string, string>;
}

export const SigningAppointmentDescriptionTooltip: React.FC<ISigningAppointmentDescriptionTooltipProps> = ({
  type,
  option,
  optionDescriptions,
}) => {
  const optionDescription = optionDescriptions[option.value];
  return (
    <Grid templateColumns={'1fr min-content'}>
      <SmallBodyText>
        {option.label}
        <Show when={!!optionDescription}>
          <Tooltip
            tooltipContent={
              <SmallBodyText style={{ width: '300px' }}>
                <div data-test-id={`signing-appointment-${type}-tooltip`}>{optionDescription}</div>
              </SmallBodyText>
            }
            trigger={'hover'}
            placement={'right'}
          >
            <FontAwesomeIcon icon={faInfoCircle} style={{ paddingTop: '3px', marginLeft: '5px' }} />
          </Tooltip>
        </Show>
      </SmallBodyText>
    </Grid>
  );
};
